import { VendorRebateCategoryProgramRebates } from '../../../components/Vendor/RebateCategoryProgramRebates';

export function RebateCategoryProgramRebates() {
  return <VendorRebateCategoryProgramRebates />;
}
